import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';
import Search from '@ifeng/ui_pc_search';
import errorBoundary from '@ifeng/errorBoundary';

class Inner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    createHtml = () => {
        return { __html: this.props.content };
    };
    render() {
        return <div className={style.h_theLogo} dangerouslySetInnerHTML={this.createHtml()} />;
    }
}

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={style.h_searchDiv}>
                <Inner content={content.bannerLogo} />
                <div className={style.link}>
                    <a href="//www.ifeng.com/">凤凰网首页</a>
                    <div>|</div>
                    <a href="//finance.ifeng.com/">财经首页</a>
                    <div>
                        <div>
                            [<a href="//finance.ifeng.com/news/">资讯</a>]
                        </div>
                        <div>
                            [<a href="//finance.ifeng.com/opinion/">评论</a>]
                        </div>
                        <div>
                            [<a href="//finance.ifeng.com/money/">股票</a>]
                        </div>
                        <div>
                            [<a href="//finance.ifeng.com/fund/">理财</a>]
                        </div>
                    </div>
                </div>
                <Search content={content.search} />
            </div>
        );
    }
}

export default errorBoundary(Banner);
